class Params extends URLSearchParams {
  setWithHistory (name, value) {
    this.set(name, value)
    const url = new URL(window.location.toString())
    url.search = this.toString()
    window.history.pushState({ [name]: value }, '', url.toString())
  }

  deleteWithHistory (name) {
    this.delete(name)
    const url = new URL(window.location.toString())
    url.search = this.toString()
    window.history.replaceState(Object.fromEntries(this.entries()), '', url.toString())
  }
}

const params = window._params || new Params(document.location.search.substring(1))
window._params = params

export default params
